import { useTheme } from '@emotion/react';
import { FoldingCube } from 'better-react-spinkit';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import api, { ApiResponse } from '../../api';
import { endpoints } from '../../endpoints.config';
import { Toast, ToastMessageReason } from '../../helpers/toast';
import { ModalTypes, closeModal, selectModalState } from '../../reducers/modal';
import { refreshPayeeTable } from '../../reducers/payee';
import Button from '../button/Button';
import { Modal } from '../modal/Modal';

export const RemovePayeeModal = () => {
    const modalState = useSelector(selectModalState);

    const [loading, setLoading] = useState(false);

    const { colors } = useTheme();
    const dispatch = useDispatch();
    const { t } = useTranslation(['moveMoney', 'common']);

    const handleClose = () => dispatch(closeModal());

    if (modalState.modalType !== ModalTypes.REMOVE_PAYEE) return null;

    const payee = modalState.data;

    const handleRemovePayee = async () => {
        try {
            setLoading(true);
            const payeeId = payee.payees__Id;
            const res = await api.post<ApiResponse>(endpoints.accounts.deletePayee, {
                payeesId: payeeId,
            });

            if (res.data.status === '1') {
                dispatch(refreshPayeeTable());
                handleClose();
                Toast.openToastMessage(t('payeeRemoved'), ToastMessageReason.VALID);
            } else {
                throw new Error();
            }
        } catch (error: any) {
            Toast.openToastMessage(t('couldntDeletePayee'), ToastMessageReason.ERROR);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal className="RemovePayeeModal" title={t('common:areYouSure')}>
            {loading && (
                <div className="Loading">
                    <FoldingCube color={colors.first} size={80} />
                    <p>
                        {t('removing')} <span>{payee.payees__Name}</span>
                    </p>
                </div>
            )}

            {!loading && (
                <>
                    <p>{t('confirmRemovePayee', { name: payee.payees__Name })}</p>
                    <div className="Buttons">
                        <Button onClick={handleClose} priority="secondary" color="grey">
                            {t('common:close')}
                        </Button>
                        <Button onClick={handleRemovePayee} color="third">
                            {t('removePayee')}
                        </Button>
                    </div>
                </>
            )}
        </Modal>
    );
};
